import {css} from '@emotion/react';

export const mixins = {
  dlFlexBoxContainerInContainer: css`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
  `,
  dlButtonAsLink: css`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
  `,
  dlPageLink: css`
    padding: 0 5px;
    margin-right: 3px;

    &:hover,
    &:focus,
    &:active:focus,
    &:active:hover {
      z-index: 2;
      outline: none;
    }
  `,
  dlTextOverflowEllipses: css`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  `,
  dlButtonAsLinkDecorated: css`
    background: none;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    color: var(--dlLinkColor);
    &:hover {
      text-decoration: underline;
    }
  `,
  contentWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
  `,
  content: css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 100%;
    padding: 0;
    width: 100%;
  `,
  contentBoxWrapper: css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
    padding: 0;
    width: 100%;
  `,
  contentBox: css`
    display: flex;
    flex: 0 1 auto;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    width: 100%;
  `,
};
